import { CSSProperties, FC } from 'react';
import { TabsTypeProps, TabSize, TabThemes } from './TypeProps';
import { Tab } from './Tab/Tab';
import classNames from 'classnames';

import styles from './Tabs.module.scss';

export const Tabs: FC<TabsTypeProps> = ({
  className,
  tabs,
  active,
  countTab = 4,
  size = TabSize.Big,
  themes = TabThemes.Primary,
  handlerBackValue,
}) => {
  return (
    <div
      className={classNames(styles.WrapperTabs, styles[size], styles[themes], { [styles.fullWidth]: countTab >= 4 }, className)}
      style={{ '--num': countTab } as CSSProperties}
    >
      <div className={styles.Container}>
        {tabs.map((tab, index) => (
          <Tab className={styles.Tab} themes={themes} key={index} index={index} {...tab} active={active === index} handler={handlerBackValue} />
        ))}
      </div>
    </div>
  );
};
